import { AesUtil } from '../js/AesUtil';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { setBookingStatus, setPreCheckInStatus } from '../Redux/Reducers/checkInReducer';
import { current_client_config, currentIP, GLOBAL_IV, GLOBAL_SALT } from '../config/Constant';
import { setInitAppLogout } from '../Redux/Reducers/appConfigReducer';

export const handleBookingDataState = (forceRemoveData = false, isBookingFound = (status) => {}) => {


    return async (dispatch, getState) => {
        const aesUtil = new AesUtil(128, 1000);

        const { isLoggedIn } = getState().appConfigSlice;
        const { serverTimeDataObj } = getState().serverDateTimeSlice;


        const bookingDataAsPerHotel = await AsyncStorage.getItem("X_BOOKING_DATA_HOTEL_SPECIFIC_LIST");

        const allBookingData = bookingDataAsPerHotel && JSON.parse(bookingDataAsPerHotel);
        const bookingData = allBookingData?.[current_client_config];

        try {
            if (bookingData) {
                const bookingDataParse = JSON.parse(aesUtil.decrypt(GLOBAL_SALT, GLOBAL_IV, "1234567891234567", bookingData));

                if (isLoggedIn || forceRemoveData) {
                    delete allBookingData[current_client_config];
                    await AsyncStorage.setItem("X_BOOKING_DATA_HOTEL_SPECIFIC_LIST", JSON.stringify(allBookingData));
                    dispatch(setBookingStatus({
                        isBookingFound: false,
                        bookingData: {}
                    }))
                    return;
                }

                const serverDateObj = new Date(serverTimeDataObj?.date?.slice(0, 10));
                const checkinDateObj = new Date(bookingDataParse.checkinDate);
                const plannedCheckOutDateObj = bookingDataParse.plannedCheckOutDate ? new Date(bookingDataParse.plannedCheckOutDate.split('T')[0]) : null;

                if (plannedCheckOutDateObj) {
                    if (plannedCheckOutDateObj < serverDateObj) {
                        delete allBookingData[current_client_config];
                        await AsyncStorage.setItem("X_BOOKING_DATA_HOTEL_SPECIFIC_LIST", JSON.stringify(allBookingData));
                        dispatch(setInitAppLogout(true));
                        return;
                    }
                } else {
                    if (serverDateObj > checkinDateObj) {
                        delete allBookingData[current_client_config];
                        await AsyncStorage.setItem("X_BOOKING_DATA_HOTEL_SPECIFIC_LIST", JSON.stringify(allBookingData));
                        dispatch(setInitAppLogout(true));
                        return;
                    }
                }

                AsyncStorage.setItem("connectorIP", currentIP);
                AsyncStorage.setItem("clientId", current_client_config);
                dispatch(setBookingStatus({
                    isBookingFound: true,
                    bookingData: bookingDataParse
                }))
                isBookingFound && isBookingFound(true);
            } 
            else {
                isBookingFound && isBookingFound(false);
            }
        } catch (error) {
            console.log("error parsing booking data");
        }
    }
}


export const handlePreCheckInDataState = (forceRemoveData) => {

    return async (dispatch, getState) => {
        const aesUtil = new AesUtil(128, 1000);

        const { isLoggedIn } = getState().appConfigSlice;
        const { serverTimeDataObj } = getState().serverDateTimeSlice;

        const preCheckInDataAsPerHotel = await AsyncStorage.getItem("X_CHECKIN_PQ_DATA_HOTEL_SPECIFIC_LIST");

        const allPreCheckInData = preCheckInDataAsPerHotel && JSON.parse(preCheckInDataAsPerHotel);
        const preCheckInData = allPreCheckInData?.[current_client_config];

        try {
            if (preCheckInData) {

                if (isLoggedIn || forceRemoveData) {
                    delete allPreCheckInData[current_client_config];
                    await AsyncStorage.setItem("X_CHECKIN_PQ_DATA_HOTEL_SPECIFIC_LIST", JSON.stringify(allPreCheckInData));
                    dispatch(setPreCheckInStatus({
                        preCheckInCompleted: false,
                        preCheckInData: {},
                    }));
                    return;
                }

                const preCheckInDataParse = JSON.parse(aesUtil.decrypt(GLOBAL_SALT, GLOBAL_IV, "1234567891234567", preCheckInData));

                const serverDateObj = new Date(serverTimeDataObj?.date?.slice(0, 10));
                const checkinDateObj = new Date(preCheckInDataParse.checkinDate);
                const plannedCheckOutDateObj = preCheckInDataParse.plannedCheckOutDate ? new Date(preCheckInDataParse.plannedCheckOutDate.split('T')[0]) : null;

                if (plannedCheckOutDateObj) {
                    if (plannedCheckOutDateObj < serverDateObj) {
                        delete allPreCheckInData[current_client_config];
                        await AsyncStorage.setItem("X_CHECKIN_PQ_DATA_HOTEL_SPECIFIC_LIST", JSON.stringify(allPreCheckInData));
                        dispatch(setInitAppLogout(true));
                        return;
                    }
                } else {
                    if (serverDateObj > checkinDateObj) {
                        delete allPreCheckInData[current_client_config];
                        await AsyncStorage.setItem("X_CHECKIN_PQ_DATA_HOTEL_SPECIFIC_LIST", JSON.stringify(allPreCheckInData));
                        dispatch(setInitAppLogout(true));
                        return;
                    }
                }

                AsyncStorage.setItem("connectorIP", currentIP);
                AsyncStorage.setItem("clientId", current_client_config);
                dispatch(setPreCheckInStatus({
                    preCheckInCompleted: true,
                    preCheckInData: preCheckInDataParse
                }))
            }
        } catch (error) {
            console.log("error parsing pre check-in data")
        }
    }
};